import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import Logo from './Logo';
import { NAV_LINKS } from '../mock';

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [active, setActive] = useState('#home');

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 20);
      // determine which section is closest to top
      const ids = NAV_LINKS.map((l) => l.href.slice(1));
      let current = ids[0];
      for (const id of ids) {
        const el = document.getElementById(id);
        if (el) {
          const rect = el.getBoundingClientRect();
          if (rect.top <= 120) current = id;
        }
      }
      setActive('#' + current);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Extra push down past the navbar so the section lands lower/further in.
  // Increase this to scroll further down; decrease (or go negative) to land higher.
  const SCROLL_OFFSET = 60;

  const handleClick = (e, href) => {
    e.preventDefault();
    const isMobileMenuOpen = open;
    setOpen(false);

    const doScroll = () => {
      const el = document.querySelector(href);
      if (!el) return;
      const navbarHeight = document.querySelector('header')?.offsetHeight || 0;
      const targetY =
        el.getBoundingClientRect().top +
        window.scrollY -
        navbarHeight +
        SCROLL_OFFSET;
      window.scrollTo({ top: targetY, behavior: 'smooth' });
    };

    // On mobile, wait for the menu to collapse before scrolling
    // so the navbar height is stable and scroll-margin-top lands correctly.
    if (isMobileMenuOpen) {
      setTimeout(doScroll, 50);
    } else {
      doScroll();
    }
  };

  return (
    <header className={`sticky top-0 z-50 transition-colors duration-300 ${scrolled ? 'bg-[#0A1628]/95 backdrop-blur-md border-b border-white/5' : 'bg-transparent'}`}>
      <div className="w-full px-4 md:px-6 h-16 md:h-20 flex items-center">
        <a href="#home" onClick={(e) => handleClick(e, '#home')} aria-label="Bluu Sky Home" className="flex-shrink-0 mr-auto">
          <Logo compact />
        </a>
        <nav className="hidden md:flex items-center gap-1 ml-auto">
          {NAV_LINKS.map((l) => {
            const isActive = active === l.href;
            return (
              <a
                key={l.href}
                href={l.href}
                onClick={(e) => handleClick(e, l.href)}
                className={`relative px-4 py-2 rounded-md text-sm font-semibold tracking-wide transition-colors duration-200 ${
                  isActive ? 'text-[#F5901F]' : 'text-white/85 hover:text-[#F5901F]'
                }`}
              >
                {l.label}
                {isActive && <span className="absolute left-1/2 -translate-x-1/2 -bottom-0.5 h-0.5 w-6 bg-[#F5901F] rounded-full" />}
              </a>
            );
          })}
          {/* <a
            href="#contact"
            onClick={(e) => handleClick(e, '#contact')}
            className="ml-3 inline-flex items-center px-4 py-2 rounded-md bg-[#F5901F] text-black text-sm font-bold hover:bg-[#ffa337] transition-colors shadow-lg shadow-[#F5901F]/20"
          >
            Request Demo
          </a> */}
        </nav>
        <button
          aria-label={open ? 'Close menu' : 'Open menu'}
          className="md:hidden text-white p-2 rounded hover:bg-white/5 ml-auto"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <div className="md:hidden bg-[#0A1628] border-t border-white/5 animate-fadeInUp">
          <div className="px-4 py-3 flex flex-col">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={(e) => handleClick(e, l.href)}
                className={`px-3 py-3 rounded-md text-sm font-semibold ${
                  active === l.href ? 'text-[#F5901F] bg-white/5' : 'text-white/85'
                }`}
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={(e) => handleClick(e, '#contact')}
              className="mt-2 mx-3 px-4 py-2 rounded-md bg-[#F5901F] text-black text-sm font-bold text-center"
            >
              Request Demo
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;